import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { HOSTNAME_TOKEN } from "@white-label/hostname.token";
bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
        ...appConfig.providers,
        { provide: HOSTNAME_TOKEN, useFactory: ()=> null },
    ]})
  .catch((err) => console.error(err));
